import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combine class names with Tailwind merge strategy.
 * Standard shadcn/ui helper. Use `cn(...)` everywhere a className mix is needed.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
